import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const RiskDisclosure = () => {
  return (
    <div>
      <Navbar />
       <section className="in_page p70 bg4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <h1 className="hadding">Risk Disclosure</h1>
              <p>Trading on margin and using leveraged financial products involves significant risk. Before engaging with Dyntech’s platforms, please read this statement carefully to understand potential market, liquidity, and operational risks.</p>
            </div>
            <div className="col-md-4 m-auto">
              <img
                src="/img/risk.png"
                alt="Risk"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="in_page p70 bg2">
        <div className="container">
          <h2 className="hadding">Key Risk Factors</h2>
          <h5 className="mb-3">1. Market Risk</h5>
          <ul className="list mb-4 mb-md-5">
            <li>  Prices of equities, FX, commodities, and digital assets can move swiftly and unpredictably. </li>
            <li>Historical performance is not indicative of future results.</li> 
          </ul>
          
          <h5 className="mb-3">2. Leverage Risk</h5>
          <ul className="list mb-4 mb-md-5">
            <li> Leverage magnifies both gains and losses. A small adverse price movement can result in rapid, substantial losses exceeding your initial margin. </li>  
          </ul>
          <h5 className="mb-3">3. Liquidity Risk</h5>
          <ul className="list mb-4 mb-md-5">
            <li> In certain market conditions, it may be difficult or impossible to execute orders at desired prices or sizes, potentially increasing slippage. </li>  
          </ul>
          <h5 className="mb-3">4. Counterparty Risk </h5>
          <ul className="list mb-4 mb-md-5">
            <li> Although we partner with top-tier liquidity providers, adverse events (e.g., defaults) at the counterparty level may impact trade execution or settlement. </li> 
          </ul>
          <h5 className="mb-3">5. Operational Risk</h5>
          <ul className="list mb-4 mb-md-5">
            <li> System outages, software bugs, and cybersecurity incidents can disrupt your ability to trade or access funds. Dyntech maintains robust redundancy and security protocols, but residual risk remains. </li> 
          </ul>
  </div>
      </section>
 <section className="in_page p70 ">
        <div className="container">
        <h3 className="mb-3"><b>Important Notices</b></h3>
           
          <ul className="list">
            <li><b> No Investment Advice: </b>Dyntech does not provide personal investment advice. You are solely responsible for your trading decisions. </li> 
            <li><b>Regulatory Status: </b> Dyntech’s platform provider services may be offered through regulated entities in your jurisdiction. Always verify applicable license disclosures.
 </li> 
            <li><b>Ask Questions: </b> Consult with your financial, tax, and legal advisors before trading. </li> 
          </ul>
          
      
          
          
          <h3 className=" mt-4 mt-md-5 mb-3"><b>Full Disclosure Statement</b></h3> 
          <p>
           For complete details on margin requirements, force-liquidation policies, and risk management procedures, view our full Risk Disclosure PDF.

          </p>
       
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default RiskDisclosure;
